'use client';
import { Box } from '@mui/material';
import type { ReactNode } from 'react';

export default function LoginLayout({ children }: { children: ReactNode }) {
  return (
    <Box
      sx={{
        height: '99%',
        width: '100%',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center'
      }}
    >
      <Box
        sx={{
          maxWidth: 600,
          marginX: 'auto'
        }}
      >
        {children}
      </Box>
    </Box>
  );
}
